var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"developing"},[_c('img',{attrs:{"src":require("@/assets/img/razrabotka.png"),"alt":""}}),_c('div',{staticClass:"developing__text"},[_c('b-spinner',{staticClass:"developing__spinner",attrs:{"variant":"primary"}}),_vm._v(" Пожалуйста зайдите позднее... ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }